module.exports = __webpack_public_path__ + "static/media/LOADER_10.ce05d7c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_10.png
// module id = 318
// module chunks = 0